<template>
  <span class="message">{{ message }}</span>
</template>

<script>
export default {
  name: 'SingleMessage',

  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },

  computed: {
    message () {
      return this.question.message.config.value
    }
  }
}
</script>

<style lang="scss" scoped>
  .message {
    @media (max-width: $screen-md) {
      font-size: 15px;
    }
  }
</style>
